import { ButtonVariant } from 'components/Button/Button.types';
import {
  inspiredAnimation,
  likeAnimation,
  loveAnimation,
} from 'components/LottieAnimation/lottieAnimationsData';

export const REACTIONS = {
  LIKE: {
    animation: likeAnimation,
    text: getText('Like'),
    buttonVariant: 'reaction-like' as ButtonVariant,
    qaId: 'like-button',
  },
  LOVE: {
    animation: loveAnimation,
    text: getText('Love'),
    buttonVariant: 'reaction-love' as ButtonVariant,
    qaId: 'love-button',
  },
  INSPIRED: {
    animation: inspiredAnimation,
    text: getText('Inspired'),
    buttonVariant: 'reaction-inspired' as ButtonVariant,
    qaId: 'inspired-button',
  },
};
